/**
 * Copyright ©2024 Drivepoint
 */

import {State, Store} from "@bainbridge-growth/node-frontend";
import PlanService from "../services/PlanService.ts";

/**
 * @deprecated: replace with `const plan = useStateChange("plan");` or methods in PlanService
 */

export default class PlanStore extends Store {

  init(): void {
    this.loading = true;
    State.registerMany("plan", () => {
      return this.action(async () => {
        this.value = PlanService.plan;
        if (PlanService.plan?.error) { throw PlanService.plan.error; }
      });
    });
  }

}
